import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ThemeToggle" }
const _hoisted_2 = { class: "image-wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

import { ref, onMounted, onBeforeUnmount } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ThemeToggle',
  props: {
    isDark: { type: Boolean }
  },
  emits: ['toggle'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const setDay = () => {
  if (props.isDark) emit('toggle')
}

const setNight = () => {
  if (!props.isDark) emit('toggle')
}

const dayImg = new URL('@/assets/image/daynight_day.png', import.meta.url).href
const nightImg = new URL('@/assets/image/daynight_night.png', import.meta.url).href

const showFloatingToggle = ref(false)

const handleScroll = () => {
  showFloatingToggle.value = window.scrollY > 800
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)

  // ✅ 이미지 미리 로딩
  const preloadDay = new Image()
  preloadDay.src = dayImg

  const preloadNight = new Image()
  preloadNight.src = nightImg
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(dayImg),
        class: _normalizeClass(["background", { visible: !_ctx.isDark }]),
        alt: "Day"
      }, null, 10, _hoisted_3),
      _createElementVNode("img", {
        src: _unref(nightImg),
        class: _normalizeClass(["background", { visible: _ctx.isDark }]),
        alt: "Night"
      }, null, 10, _hoisted_4),
      _createElementVNode("button", {
        class: "click-zone day",
        onClick: setDay
      }),
      _createElementVNode("button", {
        class: "click-zone night",
        onClick: setNight
      })
    ]),
    (showFloatingToggle.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass(['theme-toggle', _ctx.isDark ? 'day-mode' : 'night-mode']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle')))
        }, _toDisplayString(_ctx.isDark ? '☀️' : '🌙'), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})